import {Component} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';

import {TranslateModule} from '@ngx-translate/core';
import {IonCol, IonRow, IonText} from '@ionic/angular/standalone';

@Component({
    selector: 'string-formly-type',
    template: `
      <ion-row>
        <ion-col class="ion-no-padding">
          <div style="margin-top: 16px; margin-bottom: 16px;">
            <ion-text color="medium">
              <h6 class="ion-no-margin">
                {{ props.label }}
              </h6>
              @if (props.description) {
                <div>
                  <small style="margin-top: 4px;">{{ props.description }}</small>
                </div>
              }
            </ion-text>
          </div>
        </ion-col>

        @if (showError && formControl.errors) {
          <ion-col class="ion-no-padding">
            <formly-validation-message [field]="field"></formly-validation-message>
          </ion-col>
        }
      </ion-row>

      @for (fieldGroup of field.fieldGroup; track fieldGroup) {
        <formly-field [field]="fieldGroup"></formly-field>
      }
    `,
  imports: [TranslateModule, FormlyModule, IonCol, IonText, IonRow]
})
export class ObjectFormlyType extends FieldType {
}
